import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.29991 14.422V10.1667C9.29991 9.93686 9.39122 9.71642 9.55375 9.55389C9.71628 9.39136 9.93672 9.30005 10.1666 9.30005H14.4219M4.96673 4.9667H11.9001M4.96673 7.56672H8.00006M8.9412 14.5H2.36667C2.13681 14.5 1.91637 14.4087 1.75384 14.2462C1.59131 14.0836 1.5 13.8632 1.5 13.6333V2.36667C1.5 2.13681 1.59131 1.91637 1.75384 1.75384C1.91637 1.59131 2.13681 1.5 2.36667 1.5H13.6333C13.8632 1.5 14.0836 1.59131 14.2462 1.75384C14.4087 1.91637 14.5 2.13681 14.5 2.36667V8.9412C14.5 9.17089 14.4087 9.39117 14.2464 9.55364L9.55364 14.2464C9.39117 14.4087 9.17089 14.5 8.9412 14.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDocument;
